module.exports = __webpack_public_path__ + "rightCircleActive.96aaa773.png";